import { __assign } from 'tslib';
import * as React from 'react';

// TODO: this SVG component should be replaced by Decorative shape once
// https://invitae.jira.com/browse/WT-19127 is implemented
var CropSideShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "cropSideShape", viewBox: "0 0 1294 242", width: "100%", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        React.createElement("defs", null,
            React.createElement("path", { d: "M0 0h1294v242H0z", id: "prefix__a" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M73 405C88.477 223.57 180.684 118.179 349.62 88.825c253.405-44.03 176.074 72.567 530.301 100.505 236.152 18.625 350.034 90.515 341.648 215.67H73z", fill: "#F7E0A6", mask: "url(#prefix__b)" }))));
};

export { CropSideShape as default };
//# sourceMappingURL=CropSideShape.esm.js.map
